<div>
  @for (entity of dialogData.invalidEntityList; track entity.entityId) {
    <div class="mb-16">
      <div class="row mb-8 items-center">
        @if (entity.entityType) {
          <icz-icon size="small" [svgIcon]="entityIcon(entity.entityType)"></icz-icon>
        }
        <div class="font-bold">{{ (entity.refNumber ?? WITHOUT_REF_NUMBER | translate) + ' - ' + entity.subject }}</div>
      </div>
      <div class="row mb-4 pl-24 items-center">
        <icz-alert severity="info" alertMode="compact" [label]="entity.errorCode!"></icz-alert>
      </div>
    </div>
  }
</div>
<icz-form-buttons>
  <icz-button rightButtons (onAction)="close()" label="Storno"></icz-button>
</icz-form-buttons>
